import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-metrics-icon',
  templateUrl: './metrics-icon.component.html',
  styleUrls: ['./metrics-icon.component.scss']
})
export class MetricsIconComponent implements OnInit {
  @Input() unit_name:any;
  @Input() scale = 1;
  constructor() { }

  ngOnInit(): void {
  }


}
